const SgiButtonEO = function () {
    return {
        ann: "注释",
        // badgeText: "5",//右上角标
        // btnIconPh: "search",//按钮图标
        // cId: "cid_button",//组件标识
        // ctlH: 0,
        ctlN: "按钮",
        // ctlW: 100,
        desId: "EP_EO_UI_3003",
        // hvInfo: "按钮的提示信息",//按钮的提示信息
        isDis: false,
        isHdn: false,
        te: "显示名称",
        // bdrW: 20,//边框宽度
        // csstyle: "button-default",
        // fontIcon: "",//字体图标
        // iconAlg: "left",//按钮图片位置
        // iconPh: "SD_RP_IR_0001`UI`UI10",
        // isBrdr: true,//是否有边框,显示边框
        // mgn: 10,//外边距
        // n: "名称",
        // pad: 10,//内边距
        // new_flag: true,
        // sNo: 0,//排序号
        // bkImgPh: "SD_RP_IR_0001`UI`UI10",//背景图片
        // bkImgRptType: "",//背景图重复方式
        // teAl: "center",//文本位置
        // teid: "20171123172212960752",//显示名称代码
        // useTim: 0,//使用次数
        // visible: true,
        // x: "0",
        // y: "0",
    }
}
export { SgiButtonEO };
export default SgiButtonEO;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiButtonEO.js